"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InboxOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.84 17.62L24.52 5.21A2 2 0 0022.68 4H9.32a2 2 0 00-1.84 1.21L2.16 17.62a2.1 2.1 0 00-.16.79V26a2 2 0 002 2h24a2 2 0 002-2v-7.59a1.92 1.92 0 00-.16-.79zM28 26H4v-7.59L9.32 6h13.36L28 18.41z"/><path d="M20.59 20h-9.18l-1.56-1.57A1.5 1.5 0 008.79 18H7a1 1 0 000 2h1.59l1.56 1.57a1.49 1.49 0 001.06.43h9.58a1.49 1.49 0 001.06-.43L23.41 20H25a1 1 0 000-2h-1.79a1.5 1.5 0 00-1.06.44zm-11.8 0z"/>';
var InboxOutlineSVG = function InboxOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.InboxOutlineSVG = InboxOutlineSVG;
InboxOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(InboxOutlineSVG);
exports.default = _default;